/**
 * Format a number in Indian locale with no decimal places.
 * Truncates (does not round): 22523203.41 → "2,25,23,203"
 */
export function formatWithoutDecimal(value, fallback = "0") {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.trunc(n).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

/** Same as formatWithoutDecimal, prefixed with ₹ */
export function formatInrWithoutDecimal(value, fallback = "0") {
  return `₹${formatWithoutDecimal(value, fallback)}`;
}

/** @deprecated Prefer PrivacyBlur — kept as plain format for callers. */
export function formatInrWithoutDecimalMaybeHidden(
  value,
  _valuesHidden,
  fallback = "0",
) {
  return formatInrWithoutDecimal(value, fallback);
}

/** @deprecated Prefer PrivacyBlur — kept as plain format for callers. */
export function formatWithoutDecimalMaybeHidden(
  value,
  _valuesHidden,
  fallback = "0",
) {
  return formatWithoutDecimal(value, fallback);
}
